import { render, staticRenderFns } from "./ReportControls.vue?vue&type=template&id=dd8c1670"
import script from "./ReportControls.vue?vue&type=script&lang=js"
export * from "./ReportControls.vue?vue&type=script&lang=js"
import style0 from "./ReportControls.vue?vue&type=style&index=0&id=dd8c1670&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports